import { selectElement } from "../utils/element-handlers.utils";

export default function restaurantCareerPositionPage() {
    selectElement<HTMLFormElement>('form#Form_CareerPositionForm', careerPositionformElement => {
        const formAction = careerPositionformElement.getAttribute('action');

        if (formAction) {
            careerPositionformElement.setAttribute('action', formAction.replace('CareerPositionForm', 'application'))
        }
    });
}
